/* eslint-disable */

import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import PhoneMediaPreview from "./PhoneMediaPreview";
import { listLanguage } from 'containers/NewWaTemplate/ListDropdownData';
const customStyles = {
  content: {
    // border: "0",
    borderRadius: '10px',
    // padding: 0,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    border: '1px solid #EBECF0',
    boxShadow: '1px 1px 20px rgba(170, 170, 170, 0.2)',
    maxHeight: '95vh'
  },
};

import CopiedTemplate from "../../_assets/svg/copy_logo.svg";
import { unescape } from "lodash";

function PreviewTemplate(props) {
  const { isPreviewTemplate, setPreviewTemplate, isInfoSelected } = props;
  // const [isOpenModalPreview, setOpenModalPreview]=useState(false);
  // const [isShowAlertsPreview,setShowAlertsPreview]=useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isShowCopied, setShowCopied] = useState(false);
  const [isSelectedLanguage, setSelectedLanguage] = useState([]);
  let previewData;
  let prevButtons = [];
  let header = { type: "", text: "" };
  let footer = { type: "", text: "" };
  let body_template = "";

  function closeModal() {
    setOpenModal(false);
    setPreviewTemplate(false);
  }

  function handleSaveModal() {
    handleSaveAction(isInfoSelected);
    setOpenModal(false);
  }

  useEffect(() => {
    if(listLanguage){
      listLanguage.forEach((langData) => {
        if(langData.value === isInfoSelected?.data?.language){
          setSelectedLanguage({
            name: langData.name,
            value: isInfoSelected?.data?.language,
          });
        }
      })
    }
  }, [isInfoSelected]);

  // buttons
  if (isInfoSelected?.data?.button?.length > 0) {
      prevButtons = isInfoSelected?.data?.button
    // isInfoSelected?.data?.button.forEach((el, index) => {
    //   let eldata = {
    //     type: el.type,
    //     index: el.button_index,
    //     display: el.button_info.button_text,
    //     content: el.button_info.url,
    //   };
    //   prevButtons.push(eldata);
    // });
  }
  // header
  if (isInfoSelected?.data?.header?.type != "none") {
    header = { type: isInfoSelected?.data?.header?.type, text: "" };
    if (header.type == "text") {
      header.text = isInfoSelected?.data?.header?.text?.body?.body ? isInfoSelected?.data?.header?.text?.body?.body : isInfoSelected?.data?.header?.text?.body ;
    }
  }
  
  // body
  // function containsEncodedComponents(x) {
  //   // ie ?,=,&,/ etc
  //   return typeof x === 'string' && decodeURI(x) !== decodeURIComponent(x);
  // }
  
  // const checkAnyEncoded = containsEncodedComponents(isInfoSelected?.data.body);
  // const bodyMess = encodeURIComponent(isInfoSelected?.data.body);
  let resultBodyMessage = ''
  try {
    resultBodyMessage = decodeURIComponent(isInfoSelected?.data.body);
  }
  catch (e) {
    resultBodyMessage =  unescape(isInfoSelected?.data.body);                                       
  }
  
  body_template = setBodyMessage(resultBodyMessage);
  // if(checkAnyEncoded){
  //   body_template = setBodyMessage(decodeURIComponent(bodyMess));
  // }else{
  //   body_template = setBodyMessage(decodeURIComponent(bodyMess));
  // }

  if(body_template.includes('[123456]')){
    body_template = body_template.replace('[', '')
    body_template = body_template.replace(']', '')
  }
  
  // footer
  let dataLang = ''
  if(listLanguage){
    listLanguage.forEach((langData) => {
      if (isInfoSelected?.data?.footer) {
        footer = { type: isInfoSelected?.data?.footer?.type, text: "", nameTimes: '' };
        footer.text = isInfoSelected?.data?.footer?.text?.body?.body ? isInfoSelected?.data?.footer?.text?.body?.body : isInfoSelected?.data?.footer?.text?.body ;
      }
      if(langData.value === isInfoSelected?.data?.language){
        dataLang = langData.nameTimes;
      }
      if(isInfoSelected?.data?.footer?.footer_info){
        footer.times = `${isInfoSelected?.data?.footer?.footer_info.code_expired } ${dataLang}`
        footer.nameTimes = dataLang;
      }
    })
  }


  // media
  previewData = {
    button: prevButtons,
    header: header,
    message: body_template,
    footer: footer,
    type_category: isInfoSelected.data && isInfoSelected.data.template_category.toLowerCase()
  };

  function checkReg(str) {
    if (typeof str !== 'undefined') {
      let string = str
      string = string.replace(/_(.*?)_/g, `<i>$1</i>`)
      string = string.replace(/~(.*?)~/g, `<del>$1</del>`)
      string = string.replace(/```(.*?)```/g, `<tt>$1</tt>`)
      string = string.replace(/\*(.*?)\*/g, `<b>$1</b>`)
      string = string.replace(/(\r\n|\n|\r)/gm, "<br />");
      return { __html: string };
    }

    return { __html: str };
  }

  // function htmlDecode(input){
  //   var e = document.createElement('div');
  //   e.innerHTML = input;
  //   return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  // }

  function handleCopyId() {
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(isInfoSelected?.data?.template_code_id);

    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 2000);
    /* Alert the copied text */
    // alert("Copied the text: " + isInfoSelected.data.template_id);
  }

  function setBodyMessage(message) {
    let brackets = false;
    let underscores = [];
    let newText = message;
    for (let i = 0; i < message.length; i++) {
      const char = newText[i];
      if (char === "[") {
        brackets = true;
      }
      if (newText[i] === "_" && brackets) {
        underscores.push(i);
      }
      if (newText[i] === "]") {
        brackets = false;
      }
    }

    underscores.reverse();
    underscores.forEach((element) => {
      newText = setCharAt(newText, element, "&#95;");
    });
    return newText;
  }

  function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
  }

  console.log('isInfoSelected', isInfoSelected)

  return (
    <div>
      <Modal
        isOpen={isPreviewTemplate || isOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="modal-preview-template card">
          <div className="close-action" onClick={closeModal}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18"
                stroke="#7A869A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#7A869A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="row card-body p-4">
            <div className="col-md-8 pr-lg-4">
              <h4 className="title font-semibold color-14">{isInfoSelected.data.template_name}</h4>
              <div className="list-name">
                <span className="text">Template Code</span>
                <div className="sub-text wrap_sub_text mt-2">
                  <p className="mb-0">
                    {isInfoSelected.data.template_code_id
                      ? isInfoSelected.data.template_code_id
                      : "-"}
                  </p>
                  <img
                    onClick={handleCopyId}
                    src={CopiedTemplate}
                    className={`${isInfoSelected.data.template_code_id ? "" : "d-none"}`}
                  ></img>
                  <div className={`tooltipCopied ${isShowCopied ? "" : "d-none"}`}>Copied</div>
                </div>
              </div>
              <div className="list-name">
                <span className="text">Template Name</span>
                <p className="sub-text mt-2">{isInfoSelected.data.template_name}</p>
              </div>
              <div className="list-name">
                <span className="text">Template Category</span>
                <p className="sub-text mt-2 description_preview">
                  {isInfoSelected.data.template_category ? isInfoSelected.data.template_category : '-'}
                  </p>
              </div>
              <div className="list-name">
                <span className="text">Template Language</span>
                <p className="sub-text mt-2">{isSelectedLanguage.name ? isSelectedLanguage.name : '-'}</p>
              </div>
              <div className="list-name">
                <span className="text">Body</span>
                <div className="sub-text mt-2 body-temp custom-scrollbar pre-wrap" dangerouslySetInnerHTML={checkReg(body_template)} />
              {/* <div className="sub-text body-temp custom-scrollbar pre-wrap" dangerouslySetInnerHTML={{ __html:htmlDecode(decodeURI(isInfoSelected.data.body))}} /> */}

                {/* <div className="sub-text mt-2 body-temp custom-scrollbar pre-wrap">
                  {decodeURI(body_template)}
                </div> */}
              </div>
              {isInfoSelected.data?.status === "Rejected" && (
                <div className="list-name">
                  <span className="text">Rejected Notes</span>
                  <div className="notes">{isInfoSelected.data.notes}</div>
                </div>
              )}
            </div>
            <div className="col-md-4 px-lg-4">
              <h6 className="font-semibold color-14 mb-4">Preview</h6>
              <PhoneMediaPreview previewData={previewData}></PhoneMediaPreview>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default PreviewTemplate;
